<template>
    <div class="card">
        <header class="card-header">
            <p class="card-header-title">
                Total Sales
            </p>
        </header>
        <div class="card-content">
            <div class="content">
                <h1>{{ total_sales | formatNumber}}</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            total_sales() {
                return this.$store.getters.getProfitSectionData.total_sales
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Profit/ProfitTotalSales.vue